<template>
  <div class="salary-manage">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" type="primary">导出</el-button>
      </div>
      <div class="fr">
        <el-input v-model.trim="searchFormData.class_code_or_name" placeholder="班级名称/编号"></el-input>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      :paginConfig="paginConfig"
      @pageChange="pageChange"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:remuneration_rate="row">{{row.remuneration_rate | percent}}</template>
      <template v-slot:allSupFee="row">{{ getMisAndSup(row)}}</template>
      <template v-slot:action="row">
        <el-button type="text" v-if="row.class_id" size="small" @click="() => openInf(row)">生成</el-button>
      </template>
    </ly-table>
  </div>
</template>

<script>
import { Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import { mySalaryDetailTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import pattern from '@/utils/pattern';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'SalaryManage',
  components: {
    LyTable,
    ElInput: Input
  },
  data() {
    return {
      searchFormData: {
        class_code_or_name: ''
      },
      tableHeader: Object.freeze(mySalaryDetailTable),
      searchFormConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      tableConfig: {
        data: [],
        'span-method': ({ row, column }) => {
          if (
            column.property === 'real_name'
            || column.property === 'id_card_no'
            || column.type === 'index'
            || column.property === 'month'
            || column.property === 'action'
            || column.property === 'allSupFee'
          ) {
            if (typeof row.column === 'number') {
              return [row.column, 1];
            }
          }
          return [1, 1];
        }
      },
      paginConfig: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
      originalData: [],
      years: [],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      misList: {}, // 总缺课key - value
      supList: {} // 总代课key - value
    };
  },
  mounted() {
    this.search();
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
      }
    });
  },
  filters: {
    percent(value) {
      return typeof value === 'number' ? `${Decimal.mul(value, 100).toNumber()} %` : '';
    }
  },
  computed: {
    getMisAndSup() {
      return row => {
        if (typeof row.index === 'number' && this.misList[row.index]) {
          return Decimal.sub(this.supList[row.index] || 0, this.misList[row.index]).toNumber();
        }
        return this.supList[row.index];
      };
    },
    getMonthReal() {
      return item => {
        if (item.other && pattern.decimal.test(item.other)) {
          return Decimal.add(item.other, item.current_month_remuneration).toNumber();
        }
        return item.current_month_remuneration;
      };
    }
  },
  methods: {
    search() {
      finance
        .queryMyPayroll({
          ...this.searchFormData,
          page_no: this.paginConfig.page_no,
          page_size: this.paginConfig.page_size
        })
        .then(async res => {
          if (res && res.data && res.data.length) {
            const temp = [];
            for (let i = 0; i < res.data.list.length; i += 1) {
              const item = res.data.list[i];
              const curItem = JSON.parse(JSON.stringify(item));
              if (typeof curItem.agent_class_json === 'string') curItem.agent_class_json = JSON.parse(curItem.agent_class_json);
              const class_id_list = Object.keys(curItem.agent_class_json);
              // 总代课
              let allSupFee = 0;
              // 总缺课
              let allMisFee = 0;
              if (class_id_list.length) {
                // eslint-disable-next-line no-await-in-loop
                const classListRes = await finance.querySubstituteClass({
                  params: {
                    class_id_list
                  }
                });
                if (classListRes && classListRes.data && classListRes.data.class_info_list.length) {
                  classListRes.data.class_info_list.map(cur => {
                    const singleFee = Decimal.div(cur.class_fee, cur.courses_count);
                    allSupFee = Decimal.add(
                      Decimal.mul(singleFee, curItem.agent_class_json[cur.id] || 1),
                      allSupFee
                    ).toNumber();
                    return cur;
                  });
                }
              }
              const { class_salary_info } = curItem;
              delete curItem.class_salary_info;
              if (class_salary_info && class_salary_info.length) {
                class_salary_info.map((value, index) => {
                  if (value.miss_class_count) {
                    allMisFee = Decimal.add(
                      allMisFee,
                      Decimal.mul(value.miss_class_count, Decimal.div(value.class_fee, value.courses_count))
                    ).toNumber();
                  }
                  if (index === 0) {
                    temp.push({
                      ...curItem,
                      ...value,
                      index: i,
                      column: class_salary_info.length
                    });
                  } else {
                    temp.push({
                      ...value,
                      ...curItem,
                      index: i,
                      column: 0
                    });
                  }
                  return value;
                });
              } else {
                temp.push({
                  ...curItem,
                  index: i
                });
              }
              item.allMisFee = allMisFee;
              this.misList = {
                [i]: allMisFee,
                ...this.misList
              };
              this.supList = {
                [i]: allSupFee,
                ...this.supList
              };
            }
            this.tableConfig = {
              ...this.tableConfig,
              data: temp
            };
            this.paginConfig = {
              page_no: res.data.page_no,
              page_size: res.data.page_size,
              total: res.data.total
            };
            this.originalData = Object.freeze(res.data.list);
          }
        });
    },
    pageChange({ page_size, page_no }) {
      this.paginConfig.page_no = page_no;
      this.paginConfig.page_size = page_size;
      this.search();
    }
  }
};
</script>

<style lang="less">
.salary-manage {
  .hd {
    overflow: hidden;
    .fr {
      > .el-input,
      > .el-select {
        width: 160px;
        margin-right: 20px;
      }
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #fff;
  }
}
.create-salary {
  .input-short {
    width: 100px;
    padding: 10px;
  }
}
</style>
